import ValueCard from "@components/ValueCard";
import React from "react";

import FoodIcon1 from "@assets/images/monitoring-dashboard/food-icon-1.png";
import FlightIcon1 from "@assets/images/monitoring-dashboard/flight-icon-1.png";
import HotelIcon1 from "@assets/images/monitoring-dashboard/hotel-icon-1.png";
import AAXpressIcon1 from "@assets/images/monitoring-dashboard/aaxpress-icon-1.png";
import BeautyIcon1 from "@assets/images/monitoring-dashboard/beauty-icon-1.png";
import OurFreshIcon1 from "@assets/images/monitoring-dashboard/ourfresh-icon-1.png";
import ActivitiesIcon1 from "@assets/images/monitoring-dashboard/activities-icon-1.png";
import DealIcon1 from "@assets/images/monitoring-dashboard/deal-icon-1.png";
import HealthIcon1 from "@assets/images/monitoring-dashboard/health-icon-1.png";
import ShopIcon1 from "@assets/images/monitoring-dashboard/shop-icon-1.png";
import AARideIcon1 from "@assets/images/monitoring-dashboard/aaride-icon-1.png";
import ExtendedFlightOTAIcon1 from "@assets/images/monitoring-dashboard/exflightota-icon-1.png";
import ExtendedAARideAARideIcon1 from "@assets/images/monitoring-dashboard/extended-aaride-icon-1.png";
import InsuranceIcon from "@assets/images/monitoring-dashboard/insurance-icon-1.png";
import IKHLASIcon from "@assets/images/monitoring-dashboard/ikhlas-icon-1.png";
import SnapIcon1 from "@assets/images/monitoring-dashboard/snap-icon-1.png";

import { Grid } from "@mui/material";

let lobOptions = {
	Food: { label: "Food", color: "black", icon: FoodIcon1 },
	FlightOTA: { label: "FlightOTA", color: "orange", icon: FlightIcon1 },
	SNAP: { label: "SNAP", color: "darkblue", icon: SnapIcon1 },
	Hotel: { label: "Hotel", color: "green", icon: HotelIcon1 },
	AAXpress: { label: "AAXpress", color: "blue", icon: AAXpressIcon1 },
	Beauty: { label: "Beauty", color: "gray", icon: BeautyIcon1 },
	OurFresh: { label: "OurFresh", color: "darkgray", icon: OurFreshIcon1 },
	Activities: { label: "Activities", color: "darkyellow", icon: ActivitiesIcon1 },
	Deal: { label: "Deal", color: "red", icon: DealIcon1 },
	Health: { label: "Health", color: "darkgreen", icon: HealthIcon1 },
	Shop: { label: "Shop", color: "cyan", icon: ShopIcon1 },
	AARide: { label: "AARide", color: "#dfdc90", icon: AARideIcon1 },
	ExtendedFlightOTA: { label: "Ext. FlightOTA", color: "#763565", icon: ExtendedFlightOTAIcon1 },
	SettlementAARide: { label: "Sett. AARide", color: "#d12929", icon: AARideIcon1 },
	ExtendedAARide: { label: "Ext. AARide", color: "#76FF65", icon: ExtendedAARideAARideIcon1 },
	Insurance: { label: "Insurance", color: "#00FF65", icon: InsuranceIcon },
	IKHLAS: { label: "Ikhlas", color: "#00FF65", icon: IKHLASIcon },
};

const NewOrdersDistibutionByLOBValueCards = ({ data }) => {
	const valueCard = (label, value, icon) => <ValueCard label={label} value={value} icon={icon ? icon : null} />;

	const buildNewOrdersDistibutionByLOBValueCard = () => {
		let cards = [];
		Object.keys(lobOptions).forEach((key) => {
			let count = key in data ? data[key].values.reduce((i, c) => i + c, 0) : 0;
			cards.push(
				<Grid item xs={2} key={key}>
					{valueCard(lobOptions[key].label, count, lobOptions[key].icon)}
				</Grid>
			);
		});
		return cards;
	};

	return (
		<Grid container spacing={0} rowSpacing={1} columnSpacing={1}>
			{buildNewOrdersDistibutionByLOBValueCard()}
		</Grid>
	);
};

export default NewOrdersDistibutionByLOBValueCards;
